// Component
import { RenderGroupAnalyticsItem } from '@/components/pages/analyze-group/RenderGroupAnalyticsItem';
import AnalyticsErrorBanner from '@/components/composite/Analyze/AnalyticsErrorBanner';

// Hooks
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import useGroupAnalytics from '@/utils/hooks/swr/group/useGroupAnalytics';
import useMostEfficientSocialProfilesDisplayInfos from '@/utils/hooks/charts/useMostEfficientSocialProfilesDisplayInfos';

export const StatsGroupWrapper = ({ periodSelected, pageConfig }) => {
    const { config, fields } = pageConfig?.['base'] ?? {};

    const { activeGroup } = useActiveGroup();

    const {
        groupAnalytics,
        mostEfficientSocialProfiles,
        mutateGroupAnalytics,
        groupAnalyticsError,
        setRequestParams,
        setState,
        isLoading: isLoadingAnalytics
    } = useGroupAnalytics({
        activeGroupID: activeGroup?.id,
        params: {
            period: periodSelected?.period,
            comparison_period: periodSelected?.compareTo,
            start: periodSelected?.start,
            end: periodSelected?.end,
            parameters: {},
            fields
        },
        options: { revalidateOnFocus: false, revalidateOnReconnect: false }
    });

    const { socialProfilesDisplayInfos } = useMostEfficientSocialProfilesDisplayInfos({
        [activeGroup?.id]: mostEfficientSocialProfiles
    });

    if (!config) return null;

    return (
        <>
            <AnalyticsErrorBanner
                analyticsError={groupAnalyticsError}
                mutateAnalytics={mutateGroupAnalytics}
            />
            {config.map((config) => (
                <RenderGroupAnalyticsItem
                    key={config.id}
                    group={activeGroup}
                    config={{ ...config, groups: [activeGroup.id] }}
                    analytics={groupAnalytics}
                    mostEfficientSocialProfiles={mostEfficientSocialProfiles}
                    socialProfilesDisplayInfos={socialProfilesDisplayInfos}
                    periodSelected={periodSelected}
                    analyticsState={{
                        mutateGroupAnalytics,
                        isLoadingAnalytics,
                        setRequestParams,
                        setState
                    }}
                />
            ))}
        </>
    );
};
